import React, { useState, useEffect } from 'react';
import { useTrustyActor, useTrustyState } from '../TrustyProvider';
import { trustyConstants as c } from '../../lib/trusty.constants';
import { HoldButton } from '../../../../shared/ui';
import css from './TrustyUI.module.css';

export const UIActions = () => {
    const { send } = useTrustyActor();
    const state = useTrustyState();
    const [canAction, setCanAction] = useState(false);
    
    const isGameOver = state.matches(c.states.gameOver);
    const isIntermediate = state.matches(c.states.intermediateStats);

    useEffect(() => {
        // Додаємо невелику затримку при кожному вході в стан вибору дії
        setCanAction(false);
        const timer = setTimeout(() => setCanAction(true), 1200);
        return () => clearTimeout(timer);
    }, [state.value]); // Спрацьовує при кожній зміні стану машини

    let actionLabel = "СТАРТ";
    let actionType = c.events.START;

    if (isIntermediate) {
        actionLabel = "Далі до Сету 2";
        actionType = c.events.NEXT_SET;
    } else if (isGameOver) {
        actionLabel = "Спробувати ще раз";
        actionType = c.events.RETRY;
    }

    return (
        <div className={css.actionsContainer}>
            <HoldButton 
                onAction={() => canAction && send({ type: actionType })} 
                className={`${css.actionBtn} ${!canAction ? css.disabled : ""}`}
                disabled={!canAction}
            >
                {actionLabel}
            </HoldButton>
        </div>
    );
};
